export default {
   
    apiGoogle: 'AIzaSyDN-PoqsUljEYKVNwe_fzhitBystwHfAYI',
    Key:'pDfjQlZh4YaRwaZxItOlg9nK6DZZYXuA-0'
}